export default {
      id: "Icon--locationPersonal-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--locationPersonal",
      toString: function () {
        return this.url;
      }
    }